import { Overlay } from '@eti/components';
import { useTranslation } from '@eti/providers';
import EtgFaresDrawerContent from './EtgFaresDrawerContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EtgFaresDrawer = ({
  bounds,
  dataTestId,
  handleClose,
  isOpen,
  sellableOptions,
  title,
  tripType
}) => {
  const {
    t
  } = useTranslation();
  const generateOptionKey = index => `option_${index}`;
  const getPiecesAndWeight = (pieces, weight, weightUnit) => pieces && weight && weightUnit ? `${t('Product.BaggagePerTraveler.Pieces', pieces)} ${t('Product.BaggagePerTraveler.Weight', weight, weightUnit)}` : null;
  const getDimensions = ({
    width,
    height,
    length
  }) => t('Product.CabinBaggagePerTraveler.Dimensions', width, height, length);
  return /*#__PURE__*/_jsxs(Overlay.Drawer, {
    dataTestId: dataTestId,
    handleClose: handleClose,
    id: "product-etg-info-drawer",
    isOpen: isOpen,
    children: [/*#__PURE__*/_jsx(Overlay.Header, {
      onClose: handleClose,
      title: title
    }), /*#__PURE__*/_jsx(Overlay.Content, {
      "data-testid": `${dataTestId}-content`,
      children: sellableOptions === null || sellableOptions === void 0 ? void 0 : sellableOptions.map((feature, index) => /*#__PURE__*/_jsx(EtgFaresDrawerContent, {
        bounds: bounds,
        description: feature.description,
        dimensions: feature.size3d ? getDimensions(feature.size3d) : null,
        id: index,
        name: feature.name,
        piecesAndWeight: getPiecesAndWeight(feature.pieces, feature.weight, feature.weightUnit),
        productSpecificTexts: feature.productSpecificTexts,
        productTypeId: feature.productTypeId,
        readMoreText: feature.readMoreText,
        termsUrl: feature.termsUrl,
        tripType: tripType
      }, generateOptionKey(`product-bundle_tab_feature_${index}`)))
    })]
  });
};
export default EtgFaresDrawer;
//# sourceMappingURL=EtgFaresDrawer.js.map